import React, { useState } from 'react';

export default function WordSearch() {
  const grid = [
    ['P', 'R', 'O', 'P', 'H', 'E', 'C', 'Y', 'X', 'Z', 'L', 'Q'],
    ['E', 'F', 'O', 'R', 'E', 'T', 'E', 'L', 'L', 'I', 'N', 'G'],
    ['R', 'A', 'U', 'G', 'U', 'R', 'Y', 'V', 'M', 'N', 'O', 'T'],
    ['E', 'P', 'R', 'E', 'M', 'O', 'N', 'I', 'T', 'I', 'O', 'N'],
    ['D', 'R', 'E', 'V', 'E', 'L', 'A', 'T', 'I', 'O', 'N', 'N'],
    ['I', 'E', 'X', 'O', 'R', 'A', 'C', 'L', 'E', 'A', 'B', 'C'],
    ['C', 'S', 'V', 'I', 'S', 'I', 'O', 'N', 'D', 'E', 'F', 'G'],
    ['T', 'H', 'D', 'I', 'V', 'I', 'N', 'A', 'T', 'I', 'O', 'N'],
    ['I', 'P', 'R', 'E', 'D', 'I', 'C', 'T', 'I', 'O', 'N', 'S'],
  ];

  const words = [
    'PROPHECY',
    'PREDICTION',
    'FORETELLING',
    'REVELATION',
    'ORACLE',
    'VISION',
    'AUGURY',
    'DIVINATION',
    'PREMONITION',
  ];

  const [selected, setSelected] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const [foundWords, setFoundWords] = useState([]);

  // const rows = grid.length;
  const cols = grid[0].length;

  const getRowCol = (index) => ({
    row: Math.floor(index / cols),
    col: index % cols,
  });

  const handleMouseDown = (index) => {
    setIsDragging(true);
    setSelected([index]);
  };

  const handleMouseEnter = (index) => {
    if (isDragging && !selected.includes(index)) {
      setSelected((prev) => [...prev, index]);
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);

    if (selected.length < 2) {
      setSelected([]);
      return;
    }

    const positions = selected.map(getRowCol);

    const dRow = positions[1].row - positions[0].row;
    const dCol = positions[1].col - positions[0].col;

    const stepRow = Math.sign(dRow);
    const stepCol = Math.sign(dCol);

    // Validate straight line
    for (let i = 1; i < positions.length; i += 1) {
      const expectedRow = positions[0].row + stepRow * i;
      const expectedCol = positions[0].col + stepCol * i;

      if (
        positions[i].row !== expectedRow 
        || positions[i].col !== expectedCol
      ) {
        setSelected([]);
        return;
      }
    }

    const letters = positions.map((p) => grid[p.row][p.col]);
    const word = letters.join('');
    const reversed = [...letters].reverse().join('');

    const matchedWord = words.find(
      (w) => w === word || w === reversed,
    );

    if (matchedWord && !foundWords.includes(matchedWord)) {
      setFoundWords((prev) => [...prev, matchedWord]);
    }

    setSelected([]);
  };

  return (
    <div className="flex flex-row md:flex-col gap-6 text-white px-[80px] py-10">

      {/* GRID */}
      <div
        className="grid grid-cols-12 gap-3  rounded"
        onMouseLeave={() => setIsDragging(false)}
      >
        {grid.flat().map((letter, index) => {
          const row = Math.floor(index / cols);
          const col = index % cols;

          return (
            <button
              type="button"
              key={`${row}-${col}`}
              onMouseDown={() => handleMouseDown(index)}
              onMouseEnter={() => handleMouseEnter(index)}
              onMouseUp={handleMouseUp}
              className={`w-8 h-8 flex items-center justify-center rounded cursor-pointer select-none font-bold border border-gray-200 transition ${
                selected.includes(index)
                  ? 'bg-yellow-400 text-black'
                  : 'bg-white text-black'
              }`}
            >
              {letter}
            </button>
          );
        })}
      </div>

      {/* WORD LIST */}
      <div>
        <h3 className="font-bold mb-4 text-xl text-red-800">
          Find these words:
        </h3>

        <ul className="flex flex-wrap gap-4">
          {words.map((word) => (
            <li
              key={word}
              className={`px-3 py-1 bg-gray-800 rounded text-normal ${
                foundWords.includes(word)
                  ? 'line-through text-green-400'
                  : ''
              }`}
            >
              {word}
            </li>
          ))}
        </ul>
      </div>

    </div>
  );
}
